import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import {
  useGetAppSettingsQuery,
  useUpdateAppSettingsMutation,
} from "../../Data/services/settingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import styles from "./styles/StaticPage.module.scss";

const AppSettings = () => {
  const [deliveryCharges, setDeliveryCharges] = useState("");
  const [platformFee, setPlatformFee] = useState("");
  const [gst, setGst] = useState("");
  const [restaurantWaitTime, setRestaurantWaitTime] = useState("");

  // ⭐ New States
  const [couponDiscountPercentage, setCouponDiscountPercentage] = useState(0);
  const [userRewardPercentage, setUserRewardPercentage] = useState(0);

  const { data, isSuccess } = useGetAppSettingsQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (!_.isEmpty(data) && data.data) {
      setDeliveryCharges(data.data.delivery_charges || "");
      setPlatformFee(data.data.platform_fee || "");
      setGst(data.data.gst || "");
      setRestaurantWaitTime(data.data.restaurantWaitTime || "");

      // ⭐ New fields from API
      setCouponDiscountPercentage(data.data.coupon_discount_percentage || 0);
      setUserRewardPercentage(data.data.user_reward_percentage || 0);
    }
  }, [data]);

  const [updateAppSettings, { isLoading }] = useUpdateAppSettingsMutation();

  const handleSaveText = async () => {
    const payload = {
      delivery_charges: deliveryCharges,
      platform_fee: platformFee,
      restaurantWaitTime: restaurantWaitTime,

      // ⭐ Include new fields in update API
      coupon_discount_percentage: couponDiscountPercentage,
      user_reward_percentage: userRewardPercentage,
    };

    try {
      const response = await updateAppSettings(payload);

      if (response.error && !response.data) {
        Toast(response.error.data.message, "error");
      }

      if (!response.error && response.data.code === 200) {
        SuccessToast(response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        Toast(error.response.data.message, "error");
      } else {
        Toast("An error occurred", "error");
      }
    }
  };

  if (!isSuccess) {
    return (
      <div className={`${styles.StaticPage} text-center align-content-center`}>
        <ClipLoader color="#1C75BC" />
      </div>
    );
  }

  return (
    <div className={styles.StaticPage}>
      <Row>
        <Col sm={10}>
          <SubTitle text="App Settings" classes="mb-4" />
        </Col>
        <Col sm={2}>
          <Button
            classes={`${styles.cardBtn}`}
            text="Save"
            onClick={handleSaveText}
          />
        </Col>
      </Row>

      <p>Set your payment parameters.</p>

      <Row>
        <Col md={12}>
          <p className="m-0">Delivery Charges</p>
          <Input
            classes="mt-2 mb-3"
            type="number"
            placeholder="Enter charges"
            value={deliveryCharges}
            onChange={(e) => setDeliveryCharges(e.target.value)}
          />

          <p className="m-0">Platform Fee</p>
          <Input
            classes="mt-2 mb-3"
            type="number"
            placeholder="Enter charges"
            value={platformFee}
            onChange={(e) => setPlatformFee(e.target.value)}
          />

          <p className="m-0">VAT</p>
          <Input
            classes="mt-2 mb-3"
            type="number"
            placeholder="Enter GST"
            value={gst}
            onChange={(e) => setGst(e.target.value)}
          />

          <p className="m-0">Restaurant Wait Time</p>
          <Input
            classes="mt-2 mb-3"
            type="number"
            placeholder="Enter wait time"
            value={restaurantWaitTime}
            onChange={(e) => setRestaurantWaitTime(e.target.value)}
          />

          {/* ⭐ NEW FIELD 1 */}
          <p className="m-0">Coupon Discount </p>
          <Input
            classes="mt-2 mb-3"
            type="number"
            placeholder="Discount in percentage"
            value={couponDiscountPercentage}
           onChange={(e) => setCouponDiscountPercentage(Number(e.target.value))}
          />

          {/* ⭐ NEW FIELD 2 */}
          <p className="m-0">User Reward Percentage</p>
          <Input
            classes="mt-2 mb-3"
            type="number"
            placeholder="Enter reward %"
            value={userRewardPercentage}
onChange={(e) => setUserRewardPercentage(Number(e.target.value))}

          />
        </Col>
      </Row>
    </div>
  );
};

export default AppSettings;
